import React from 'react';
import IconArrowTop from '../IconArrowTop/IconArrowTop';

import css from './SportsListingCard.module.css';
import { UserType } from '../../util/enums';

export default function SportsListingCard(props) {
  const { step, onRedirect } = props;
  return (
    <div
      key={step.key}
      className={css.sliderItem}
      role="button"
      onClick={() =>
        onRedirect('SearchPage', null, {
          pub_pub_sports: step.key,
          pub_listingCategory: UserType.TALENT,
        })
      }
    >
      <div className={css.imageBlock}>
        <img src={step.banner} alt={step.label} />
      </div>
      <div className={css.sportsInfo}>
        <h2>{step.label} </h2>
        <IconArrowTop />
      </div>
    </div>
  );
}
